export const BREAKPOINTS = {
    PC: 1280,
    TABLET: 767,
    MOBILE: 375,
};
